import * as angular from "angular";
import * as _ from "lodash";
import {GlobalsRequestsService} from "./globals-requests.service";

export class GlobalsDialogService {

  /* @ngInject */
  constructor(private globalsRequestsService: GlobalsRequestsService, private $mdDialog, private $log, private moment) {
  }


  editGlobalProperty(event, property) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/edit-globals-dialog.html').default,
      controller: function ($scope) {

        $scope.loading = false;
        $scope.copy = angular.copy(property);

        $scope.cancel = self.$mdDialog.cancel;
        /////////////////////////////////////////////////////

        // ******************************
        // External methods
        // ******************************

        $scope.onChangeProperty = (property) => {
          $scope.copy = property;
        }

        $scope.submit = (form) => {

          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              var payloadToSend = angular.copy($scope.copy);

              if (payloadToSend && _.isEqual(payloadToSend.valueType, 'Date')) {
                payloadToSend.value = JSON.stringify(self.moment(payloadToSend.value).valueOf());
              }
              $scope.doUpdate(payloadToSend);
            }

          } else {
            self.$log.error('Form resolved to undefined!. \n' +
              '--> editPreferencesProperty@editPreferencesProperty@submit')
          }

        }

        $scope.doUpdate = (payloadToSend) => {
          $scope.loading = true;
          self.globalsRequestsService.editGlobal(payloadToSend)
            .then((updatedElement) => {
              $scope.loading = false;
              self.$mdDialog.hide(updatedElement);
            })
            .catch((error) => {
              self.$log.error('Error while updating globals value, GlobalsDialogService@editGlobalProperty: \n' + error);
            })
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }
}

angular
  .module('bringoz.admin.globals')
  .service('globalsDialogService', GlobalsDialogService);
